class CookieConsent extends HTMLElement {

    constructor() {
        super();

        this.cookie = this;

        // SHOW POPUP ONLY IF COOKIE NOT FOUND
        if (!getCookie('cookie-consent')) {

            this.cookie.style.display = "block";

            // HANDLE FULL WIDTH BANNER
            if (this.cookie.classList.contains('full-width')) {

                let cookieHeight = this.cookie.offsetHeight;

                if (cookieHeight > 0) {
                    document.body.style.paddingBottom = cookieHeight + "px";
                }

                let w = window.innerWidth;

                window.addEventListener('resize', () => {

                    if (window.innerWidth == w) return;

                    w = window.innerWidth;

                    let cookieHeight = this.cookie.offsetHeight;

                    if (cookieHeight > 0) {
                        document.body.style.paddingBottom = cookieHeight + "px";
                    }

                });

            }

        } else {
            this.remove();
        }

        // ACCEPT BUTTON
        const acceptBtn = this.querySelector('[data-accept-cookie]');

        if (acceptBtn) {

            acceptBtn.addEventListener(
                'click',
                (event) => this.setConsent(event)
            );

        }

        // CLOSE BUTTON
        const closeBtn = this.querySelector('[data-close-cookie]');

        if (closeBtn) {

            closeBtn.addEventListener(
                'click',
                (event) => this.closePopup(event)
            );

        }

    }

    // ACCEPT CONSENT
    setConsent(event, expiresDate = 365) {

        event.preventDefault();

        setCookie('cookie-consent', 'accepted', expiresDate);

        this.hidePopup();

    }

    // CLOSE WITHOUT ACCEPT
    closePopup(event) {

        event.preventDefault();

        this.hidePopup();

    }

    // HIDE POPUP
    hidePopup() {

        this.cookie.style.opacity = "0";
        this.cookie.style.transition = "opacity 0.3s ease";

        setTimeout(() => {

            this.cookie.remove();

            if (this.cookie.classList.contains('full-width')) {
                document.body.style.paddingBottom = "0px";
            }

        }, 300);

    }

}

customElements.define('cookie-consent', CookieConsent);